import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AppStateService } from './shared/services/app-state.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { TranslateService } from '@ngx-translate/core';
import { defaultLocale } from './core/functions/app-locale';

import { AuditService } from './core/services/auditService.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(
    private titleService: Title,
    private translateService: TranslateService,
    private appState: AppStateService,
    private audit: AuditService) {
    this.appState.updateState({
      menuColor : 'color',
      headerColor : 'light',
      themePrimary : "0, 46, 255"
    });

    this.translateService.setDefaultLang(defaultLocale());
    this.translateService.use(defaultLocale());

    this.translateService.get('home-title').subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
     this.audit.initRouteLogging();
  }

}
